import { ExternalLink } from "lucide-react";
import { useLang } from "../context/LangContext";
import { mediaUrl } from "../lib/api";

const STATUS_COLOR = { activa: "text-[#5698C7] border-[#5698C7]/40", desarrollo: "text-amber-500 border-amber-400/60", inactiva: "text-slate-500 border-slate-400" };
const STATUS_TEXT = { activa: "text-[#5698C7]", desarrollo: "text-amber-500", inactiva: "text-slate-500" };

export function BrandGrid({ brands }) {
  const { t, tr } = useLang();
  const lastRowStart = Math.floor(brands.length / 4) * 4;
  const remainder = brands.length % 4;
  const place = (i) => {
    if (i < lastRowStart) return "";
    if (remainder === 1) return "lg:col-start-2 lg:col-span-2";
    if (remainder === 2) return i === lastRowStart ? "lg:col-start-1" : "lg:col-start-4";
    return "";
  };
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="brand-grid">
      {brands.map((b, i) => b.logo_only ? (
        <div key={b._id} className={`p-8 relative group min-h-[230px] flex flex-col items-center justify-center text-center ${place(i)}`} data-testid={`brand-card-${i}`}>
          <img src={mediaUrl(b.logo)} alt={b.name} className="h-24 max-w-[210px] object-contain" />
          <span className={`font-mono-tech text-[10px] tracking-widest mt-4 ${STATUS_TEXT[b.status] || STATUS_TEXT.inactiva}`}>
            {t(`status_${b.status}`) || b.status}
          </span>
          <p className="text-xs text-slate-500 leading-relaxed mt-2 max-w-[240px]">{tr(b.description)}</p>
          {b.url && (
            <a href={b.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 mt-3 text-[10px] font-mono-tech text-[#5698C7] hover:text-[#0B1220] transition-colors duration-200" data-testid={`brand-link-${i}`}>
              VISITAR <ExternalLink size={10} />
            </a>
          )}
        </div>
      ) : (
        <div key={b._id} className={`hud-border bg-white p-8 relative group min-h-[230px] flex flex-col justify-between ${place(i)}`} data-testid={`brand-card-${i}`}>
          <div className="flex items-start justify-between gap-4">
            {b.logo ? (
              <img src={mediaUrl(b.logo)} alt={b.name} className="h-12 max-w-[150px] object-contain" />
            ) : (
              <div className="border border-slate-300 rounded-md px-3 py-2">
                <span className="font-display text-xs font-medium text-[#0B1220]">{b.name}</span>
              </div>
            )}
            <span className={`font-mono-tech text-[10px] tracking-widest border px-2 py-1 ${STATUS_COLOR[b.status] || STATUS_COLOR.inactiva}`}>
              {t(`status_${b.status}`) || b.status}
            </span>
          </div>
          <div>
            <h3 className="font-display text-sm font-medium mt-6 mb-2 group-hover:text-[#5698C7] transition-colors duration-200">{b.name}</h3>
            <p className="text-xs text-slate-500 leading-relaxed">{tr(b.description)}</p>
            {b.url && (
              <a href={b.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 mt-4 text-[10px] font-mono-tech text-[#5698C7] hover:text-[#0B1220] transition-colors duration-200" data-testid={`brand-link-${i}`}>
                VISITAR <ExternalLink size={10} />
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default BrandGrid;
